import { BrowserRouter as Router, Routes } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { NotificationProvider } from './context/NotificationContext';
import { AdminRoutes } from './routes/AdminRoutes';
import { AuthRoutes } from './routes/AuthRoutes';
import { ClientRoutes } from './routes/ClientRoutes';
import { GuestRoutes } from './routes/GuestRoutes';
import { HostRoutes } from './routes/HostRoutes';
import { PartnerRoutes } from './routes/PartnerRoutes';
import { PublicRoutes } from './routes/PublicRoutes';

function App() {
  // Combine all routes into a single array
  const allRoutes = [
    ...PublicRoutes,
    ...GuestRoutes,
    ...ClientRoutes,
    ...HostRoutes,
    ...PartnerRoutes,
    ...AuthRoutes,
    ...AdminRoutes
  ];

  return (
    <NotificationProvider>
      <AuthProvider>
        <Router>
          <Routes>
            {allRoutes}
          </Routes>
        </Router>
      </AuthProvider>
    </NotificationProvider>
  );
}

export default App;